import React from "react";
import { Flex } from "rebass";

export const CardFooter: React.FC<{
  right?: React.ReactNode;
  left?: React.ReactNode;
}> = ({ left, right, children }) => {
  return (
    <Flex padding={3} justifyContent="space-between">
      <div>{left}</div>
      <div>
        {children}
        {right}
      </div>
    </Flex>
  );
};
